import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { common } from 'src/app/app.common';
import { Router, ActivatedRoute } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, MaxLengthValidator, } from '@angular/forms';
import { ToastrService, ToastrComponentlessModule } from 'ngx-toastr';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatValidator } from '@angular-devkit/schematics/src/formats/format-validator';
import { forEach } from '@angular-devkit/schematics';
import { timeout } from 'rxjs/operators';
import { AbstractControl } from '@angular/forms';
import { data } from 'jquery';
import { QD5363Service } from 'src/app/utils/services/qd-5363.service';
import { ExportService } from 'src/app/utils/services/export.service';
export function removeSpaces(control: AbstractControl) {
  if (control && control.value && !control.value.replace(/\s/g, '').length) {
    control.setValue('');
  }
  return null;
}
@Component({
  selector: 'app-qd5363',
  templateUrl: './qd5363.component.html',
  styleUrls: ['./qd5363.component.scss']
})
export class QD5363Component implements OnInit {
  Token: string;
  TableView:any=[];
  NameTitle: string;
  Title: string = 'Đang tải';
  TitleClass: string = 'spinner-border text-muted';
  Request: any;
  dataTable: any = [];
  dataHeader: any = [];
  Nam_hoc_arr:any=[];
  constructor(
    private modalService: NgbModal,
    private QD5363Service: QD5363Service,
    private fb: FormBuilder,
    public router: Router,
    private fromBuilder: FormBuilder,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public exportService: ExportService
  ) { }
  dtTrigger = new Subject();
  public com: common;
  Filter = new FormGroup({
    Nam_hoc_ft: new FormControl(new Date().getFullYear()-1+"-"+new Date().getFullYear()),
    Tu_khoa_ft: new FormControl(null),
    Den_khoa_ft: new FormControl(null),
    Bieu_mau_ft: new FormControl(0)
  });
  ngOnInit() {
    let element, name, arr;
    element = document.getElementById('menu1');
    arr = element.className.split(' ');
    name = 'menu-open';
    if (arr.indexOf(name) == -1) {
      element.className += ' ' + name;
    }
    var yearNow = new Date().getFullYear();
    for (var i = 0; i < 10; i++) {
      let Nam_hoc_string = yearNow + '-' + (yearNow + 1);
      let object = {
        value: Nam_hoc_string,
        name: Nam_hoc_string,
      };
      this.Nam_hoc_arr.push(object);
      yearNow--;
    }
    this.com = new common(this.router);
    this.com.CheckLogin();
    var a = this.com.getUserinfo();
    this.Token = a.Token;
  }
  GetData() {
    this.dataHeader=[];
    this.dataTable=[];
    let req = {
      Nam_hoc: this.Filter.value.Nam_hoc_ft,
      Tu_khoa: this.Filter.value.Tu_khoa_ft==null?0:this.Filter.value.Tu_khoa_ft,
      Den_khoa: this.Filter.value.Den_khoa_ft==null?0:this.Filter.value.Den_khoa_ft,
      Bieu_mau: this.Filter.value.Bieu_mau_ft
    }
    this.spinner.show()
    this.QD5363Service.getList(req, this.Token).subscribe(z => {
      this.spinner.hide()
      if(z.Status==1){
        this.dataTable = z.Data;
        this.dataHeader=z.Header;        
      }else{
        this.toastr.error(z.Message)
      }
    })    
  }
  Excel(){
    this.com = new common(this.router);
    this.com.CheckLogin();
    var a = this.com.getUserinfo();
    let req = {
      Nam_hoc: this.Filter.value.Nam_hoc_ft,
      Tu_khoa: this.Filter.value.Tu_khoa_ft==null?0:this.Filter.value.Tu_khoa_ft,
      Den_khoa: this.Filter.value.Den_khoa_ft==null?0:this.Filter.value.Den_khoa_ft,
      Bieu_mau: this.Filter.value.Bieu_mau_ft,
      User_ID:a.Info.UserID
    }
   
    var r = confirm("File của bạn sẽ được tải xuống trong giây lát!");
    if (r) {
     
      this.spinner.show();            
      this.QD5363Service.Excel(req,a.Token)
        .subscribe(z => {
          if (z.Status == 1) {
            this.exportService.exportExcelByte(z.FileData, 'ThongKe');
            this.toastr.success("File đã được tải xuống", "Tác vụ thành công")
            this.spinner.hide();
          }
          else {
            this.toastr.error(z.Message, "Tác vụ thất bại")
            this.spinner.hide();
          }
        });
    };
  }
}
